import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(() => ({
  paperProps: {
    backgroundColor: "#F8F9FC !important",
    height: "calc(100% - 110px) !important",
    borderBottomRightRadius: "10px",
    margin: "95px 15px 15px 0",
  },
  modalProps: {
    zIndex: "99999 !important" as unknown as number,
    width: 0,
  },
  box: {
    borderRadius: "12px 12px 12px 0px",
    border: "1px solid #E4E7EC",
    padding: "12px",
    marginTop: "24px",
  },
  icon: {
    cursor: "pointer",
    fontSize: "14px",
  },
}));

export default styles;
